import { useI18n } from 'vue-i18n';

import type { Unit } from '@/typings/units/Unit';

export function useUnitBedroomDisplay() {
  const { t } = useI18n();

  function getBedroomCount(unit: Unit): string {
    if (!unit.bedrooms || unit.bedrooms <= 0) {
      return t('common.notAvailableAbbreviated');
    }

    // Check if unit has a configuration name that includes "den" or "bureau"
    const configName = unit.unitConfigurationName?.toLowerCase() || '';
    const configNameEn = unit.unitConfigurationNameEn?.toLowerCase() || '';
    const hasDen = configName.includes('bureau') || configNameEn.includes('den');
    
    const denSuffix = hasDen
      ? ` + ${t('browsingApp.units.den').toLowerCase()}`
      : '';
    
    const bedroomText = `${unit.bedrooms} ${t('browsingApp.units.bedroom', unit.bedrooms).toLowerCase()}`;
    
    return `${bedroomText}${denSuffix}`;
  }

  return {
    getBedroomCount,
  };
}